/**
 * Customer Contact Name Formatter.
 * @param {*} value
 * @param {*} row
 * @returns {*}
 */
window.customerContactNameFormatter = function(value, row) {
    if (rights.includes("customers.show.contacts.show") === 1 && value) {
        return '<a href="/customers/show/contacts/show/'+row.customer_contact_id+'">'+value+'</a>';
    } else if (value) {
        return value;
    }
};
